import { render, staticRenderFns } from "./DocumentRemarksAttachment.vue?vue&type=template&id=41704466&scoped=true&lang=pug&"
import script from "./DocumentRemarksAttachment.vue?vue&type=script&lang=js&"
export * from "./DocumentRemarksAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRemarksAttachment.vue?vue&type=style&index=0&id=41704466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41704466",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VIcon,VRow,VSimpleTable,VSpacer,VTextarea})
